<template lang="html">
    <div>
        <vs-popup :active.sync="$props.popupActive" title="Afficher les contrats et budgets" fullscreen>
            <div ref="popupContainer" class="popup-container">
            <!-- Filter Card (fixed height) -->
            <div class="filter-section" style="position: relative;">
                <FilterCard
                    :isGestion="true"
                    :isFilterButton="false"
                    :refreshKey="1"
                    :showListLength="allContracts.length"
                    :key="filterRefreshKey"
                    :isOpen="true"
                    :filters="filtersTemplates"
                    @filter="handleFilterEmits($event)"
                    :onChangeEmit="true"
                    @clearAll="resetAllFilter()"
                    :showPeriodArrows="true"
                />
                <!-- Calculator Button -->
                <div class="calculator-button-wrapper">
                    <vx-tooltip text="Calculatrice de Prix de Vente" position="left">
                        <vs-button
                            type="filled"
                            color="primary"
                            icon-pack="feather"
                            icon="icon-percent"
                            @click="openCalculator()"
                            class="calculator-button"
                        >
                            Calculatrice
                        </vs-button>
                    </vx-tooltip>
                </div>
            </div>

            <!-- Summary Cards (fixed height) -->
            <div class="budget-summary" v-if="!isLoading && allContracts.length > 0">
                <div class="summary-cards">
                    <vs-card class="summary-card">
                        <div class="summary-content">
                            <div class="flex"><h4>Total Budgets</h4><p class="ml-5">{{ selectedPeriod }}</p></div>
                            <span class="summary-amount">{{ formatCurrency(totalBudgets) }}</span>
                        </div>
                    </vs-card>
                    <vs-card class="summary-card">
                        <div class="summary-content">
                            <div class="flex"><h4>Total Consommé</h4><p class="ml-5">{{ selectedPeriod }}</p></div>
                            <span class="summary-amount">{{ formatCurrency(totalSpent) }}</span>
                        </div>
                    </vs-card>
                    <vs-card class="summary-card">
                        <div class="summary-content">
                            <div class="flex"><h4>Total Disponible</h4><p class="ml-5">{{ selectedPeriod }}</p></div>
                            <span :class="['summary-amount', totalAvailable >= 0 ? 'positive' : 'negative']">
                                {{ formatCurrency(totalAvailable) }}
                            </span>
                        </div>
                    </vs-card>
                </div>
            </div>

            <!-- Table Container (flexible height) -->
            <div class="table-container">
                <!-- Custom Table -->
                <div v-if="!isLoading" class="custom-table-wrapper">
                    <table id="budget-contracts-table" class="custom-budget-table">
                        <thead>
                            <tr>
                                <th style="width: 20px;">
                                    <div @click.stop="toggleAllExpand()" class="expand-icon-wrapper" style="cursor: pointer !important; display: flex; justify-content: center; padding: 1px; user-select: none;">
                                        <vs-icon
                                            :icon="allExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'"
                                            size="small"
                                            style="pointer-events: none;"
                                        />
                                    </div>
                                </th>
                                <th>Client</th>
								<th>Consultant</th>
                                <th>N° </th>
                                
                                <th>Statut</th>
                                <th>Période</th>
                                <th>Budget Période / Oneshot</th>
                                <th>Restant antérieur</th>
                                <th>Correction antérieur</th>
                                <th>Total Budget</th>
                                <th>Consommé Période</th>
                                <th>Disponible</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody v-for="(contract, localIndex) in paginatedContracts" :key="'row-' + localIndex">
		<tr
			@click="toggleExpandIfNotInteractive($event, getGlobalIndex(localIndex))"
			style="cursor: pointer"
			class="main-row"
		>
			<td style="width: 20px; text-align: center">
				<div
					@click.stop="toggleExpand(getGlobalIndex(localIndex))"
					class="expand-icon-wrapper"
					style="
						cursor: pointer !important;
						display: flex;
						justify-content: center;
						padding: 1px;
						user-select: none;
					"
				>
					<vs-icon
						:icon="
							expandedRows[getGlobalIndex(localIndex)]
								? 'keyboard_arrow_down'
								: 'keyboard_arrow_right'
						"
						size="small"
						style="pointer-events: none"
					/>
				</div>
			</td>
			<td :data="contract.society_name">
				<span
					class="hvr-underline"
					@click.stop="event.stopPropagation()"
					@click="displaySocietyPopup(contract.contract_society_id)"
				>
					<strong>{{ contract.society_name }}</strong>
				</span>
			</td>

			<td :data="contract.consultant_id">
				<div @click.stop="() => {}" class="consultant-cell">
					<avatar-message-chip
						:key="getGlobalIndex(localIndex)"
						:user="{
							users_id: contract.consultant_id,
							name: contract.consultant_name,
						}"
						:contract="contract"
					/>
				</div>
			</td>
						<td :data="contract.id">
				<span
					@click.stop="event.stopPropagation()"
					@click="displayContractPopup(contract.id)"
					class="hvr-underline hvr-underline-out"
				>
					{{ contract.id }}
				</span>
			</td>
			<td :data="contract.contract_status">
				<vs-chip :color="getContractStatusColor(contract.contract_status)">
					{{ getContractStatus(contract.contract_status) }}
				</vs-chip>
			</td>

			<td class="text-center" :data="contract.contract_start_date">
				{{ selectedPeriod }}
			</td>
			<td class="text-center" :data="contract.mission_budget">
				<span>
					{{
						formatCurrency(
							contract.one_shot_mission_budget || contract.mission_budget
						)
					}}
				</span>
			</td>
			<td class="text-center" :data="contract.last_budget_rest">
				<span>
					{{ formatCurrency(contract.last_budget_rest) }}
				</span>
			</td>
			<td class="text-center" :data="contract.corrected_budget">
				<span>
					{{ formatCurrency(contract.corrected_budget) }}
				</span>
			</td>
			<td class="text-center" :data="contract.total_budget">
				<span>
					<b>{{ formatCurrency(contract.total_budget) }}</b>
				</span>
			</td>
			<td class="text-center" :data="contract.total_sold_price">
				<span>
					<b>{{ formatCurrency(contract.total_sold_price) }}</b>
				</span>
			</td>
			<td class="text-center" :data="contract.budget_rest">
				<span :class="getBudgetAvailableClass(contract.budget_rest)">
					{{ formatCurrency(contract.budget_rest) }}
				</span>
			</td>

			<td class="text-center">
				<div style="display: flex; justify-content: center">
					<vx-tooltip text="Backlinks" position="top">
						<vs-button
                            
							size="small"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-link"
							@click="displayBacklinksPopup(contract, contract.items)"
						></vs-button>
					</vx-tooltip>
				</div>
			</td>
		</tr>
		<tr
			v-for="(item, indexItem) in expandedRows[getGlobalIndex(localIndex)] ? contract.items : []"
			:key="'expand-' + getGlobalIndex(localIndex) + '-item-' + indexItem"
			class="expanded-item-row"
			style="background-color: #f7f9fc"
		>
			<!-- Empty cell for expand icon column -->
			<td style="width: 20px"></td>

			<!-- Client + N° Contrat columns merged - Show Prestation name -->
			<td :colspan="2">
				<div class="flex items-center">
					<span style="color: #666">
						<strong>{{ item.mission_name }}</strong>
					</span>

					<div
						v-if="
							item.recurrence > 0 &&
							item.products_id == 136 &&
							item.is_budget_flexible_dispatched == 0 &&
							item.mission_budget <= 0
						"
						class="custom-tooltip-wrapper ml-5"
					>
						<vs-icon icon="warning" size="small" color="warning"></vs-icon>
						<div class="custom-tooltip">
							Attention le budget est pas defini au niveau de la budget flexible
							mission
						</div>
					</div>
				</div>
			</td>
			<td class="text-center">
				{{ item.mission_id }}
			</td>

			<!-- Statut du contrat column - Show Status -->
			<td>
				<vs-chip
					:color="getContractStatusColor(item.mission_status)"
					style="margin: auto"
				>
					{{ getContractStatus(item.mission_status) }}
				</vs-chip>
			</td>

			<!-- Periode column -->
			<td class="text-center">
				{{ item.recurrence == 0 ? "One shot" : selectedPeriod }}
			</td>

			<!-- Budget Période column -->
			<td class="text-center">
				<span>{{
					item.recurrence == 0
						? formatCurrency(item.one_shot_mission_budget)
						: formatCurrency(item.mission_budget) || " - "
				}}</span>
			</td>

			<!-- Restant antérieur column -->
			<td class="text-center">
				<span>{{ formatCurrency(item.last_budget_rest) }}</span>
			</td>

			<!-- Correction antérieur column for mission -->
			<td class="text-center">
				<!-- Show loader while saving -->
				<div
					v-if="savingMissions[item.mission_id || item.id]"
					style="display: flex; align-items: center; justify-content: center"
				>
					<CircularLoader :size="30" />
				</div>
				<!-- Show edit mode -->
				<div
					v-else-if="editingMissions[item.mission_id || item.id]"
					class="edit-container"
					style="
						display: flex;
						align-items: center;
						justify-content: center;
						gap: 8px;
					"
				>
					<vs-input
						v-model="
							editingMissions[item.mission_id || item.id].corrected_budget
						"
						type="number"
						step="0.01"
						class="edit-input"
						placeholder="Montant"
						style="margin: 0"
					/>
					<vs-button
						size="small"
						color="success"
						type="flat"
						icon-pack="feather"
						icon="icon-check"
						@click="saveCorrectedBudgetMission(item, contract)"
					>
					</vs-button>
					<vs-button
						size="small"
						color="danger"
						type="flat"
						icon-pack="feather"
						icon="icon-x"
						@click="cancelEditMission(item.mission_id || item.id)"
					>
					</vs-button>
				</div>
				<!-- Show display mode -->
				<div
					v-else
					style="
						display: flex;
						align-items: center;
						justify-content: center;
						gap: 8px;
					"
				>
					<span>{{ formatCurrency(item.corrected_budget || 0) }}</span>
					<div
						v-if="item.correct_budget_note"
						class="custom-tooltip-wrapper note-info-wrapper"
					>
						<vs-icon
							icon="info_outline"
							size="small"
							color="primary"
							class="note-info-icon"
						></vs-icon>
						<div class="custom-tooltip note-tooltip">
							{{ item.correct_budget_note }}
						</div>
					</div>
					<vs-button
						size="small"
						color="primary"
						type="flat"
						icon-pack="feather"
						icon="icon-edit"
						@click="startEditMission(item)"
					>
					</vs-button>
				</div>
			</td>

			<!-- Total Budget column -->
			<td class="text-center">
				<span>{{ formatCurrency(item.total_budget) }}</span>
			</td>

			<!-- Consommé column -->
			<td class="text-center">
				<span>{{ formatCurrency(item.total_sold_price) }}</span>
			</td>

			<!-- Disponible column -->
			<td class="text-center">
				<span :class="getBudgetAvailableClass(item.budget_rest)">
					{{ formatCurrency(item.budget_rest) }}
				</span>
			</td>

			<!-- Actions column for mission -->
			<td class="text-center">
				<!-- Actions moved to Correction column -->
			</td>
		</tr>
	</tbody>
                    </table>

                    <!-- Pagination -->
                    <div class="custom-pagination">
                        <div class="pagination-info">
                            Affichage {{ startItem }} - {{ endItem }} sur {{ filteredContracts.length }}
                        </div>
                        <div class="pagination-controls">
                            <vs-button
                                size="small"
                                color="primary"
                                type="flat"
                                :disabled="currentPage === 1"
                                @click="currentPage--"
                            >
                                <vs-icon icon="keyboard_arrow_left"></vs-icon>
                            </vs-button>
                            <span class="page-number">{{ currentPage }} / {{ totalPages }}</span>
                            <vs-button
                                size="small"
                                color="primary"
                                type="flat"
                                :disabled="currentPage === totalPages"
                                @click="currentPage++"
                            >
                                <vs-icon icon="keyboard_arrow_right"></vs-icon>
                            </vs-button>
                        </div>
                    </div>
                </div>

                <!-- Loading State (flexible height) -->
                <div v-else class="loading-container">
                    <CircularLoader/>
                </div>
            </div>
            </div>
        </vs-popup>

        <!-- Correction note: asked for when a budget correction is saved -->
        <!-- Correction note. Own component so it can relocate itself to <body>;
             nested inside the fullscreen popup no z-index lifts it reliably. -->
        <CorrectionNotePopup
            :popupActive.sync="showNotePopup"
            :missionName="pendingCorrection ? pendingCorrection.item.mission_name : ''"
            :period="pendingCorrection && pendingCorrection.item.recurrence == 0 ? 'One shot' : selectedPeriod"
            :amountLabel="pendingCorrection ? formatCurrency(pendingCorrection.amount) : ''"
            :existingNote="correctionNote"
            :isSaving="isSavingNote"
            @save="confirmCorrectionWithNote($event)"
            @skip="skipCorrectionNote()"
        />

        <!-- Calculator Popup (outside of main popup to fix z-index) -->
        <CalculatorPopup
            :popupActive.sync="showCalculatorPopup"
            @calculation-complete="handleCalculationComplete"
        />
    </div>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import moment from "moment";
import FilterCard from "@/views/filters/FilterCard.vue";
import store from "@/store/store";
import CircularLoader from "../widgets/loader/CircularLoader.vue";
import Netlink from "../../entities/Netlink";
import BacklinksContractPopup from "./BacklinksContractPopup.vue";
import AvatarMessageChip from "../chips/AvatarMessageChip.vue";
import ContractInfoPopup from "./ContractInfoPopup.vue";
import SocietyInfoPopup from "./SocietyInfoPopup.vue";
import CalculatorPopup from "./CalculatorPopup.vue";
import CorrectionNotePopup from "./CorrectionNotePopup.vue";

export default {
	name: "BudgetContractsPopup",
	mixins: [dbFieldConvertor],
	props: {
		popupActive: Boolean,
		productSubCategory: {
			type: Number,
			default: 7,
		},
	},
	components: {
		CircularLoader,
		FilterCard,
		BacklinksContractPopup,
		AvatarMessageChip,
		CalculatorPopup,
		CorrectionNotePopup,
	},

	data() {
		return {
			allContracts: [],
			isLoading: false,
			expandedRows: {},
			allExpanded: false,
			tableHeight: 400, // Default height, will be calculated dynamically
			selectedPeriod: moment().format("MM/YYYY"),
			netlinkStatus: [],
			filterPeriod: moment().format("MM/YYYY"),

			// Pagination
			currentPage: 1,
			itemsPerPage: 50,

			// Editing state management
			editingMissions: {},
			savingMissions: {},

			// Calculator popup
			showCalculatorPopup: false,

			// Correction note popup. Saving a correction opens this first; the
			// correction is only sent once the user confirms here.
			showNotePopup: false,
			correctionNote: "",
			pendingCorrection: null,
			isSavingNote: false,

			// Filter
			filterRefreshKey: 0,
			filtersTemplates: [
				{
					order: 0,
					emitSlugName: "filter_society",
					filterPlaceHolder: "Société",
					value: "",
					type: "Input",
				},
				{
					order: 1,
					emitSlugName: "filter_contract_id",
					filterPlaceHolder: "ID Contrat",
					value: "",
					type: "Input",
				},
				{
					order: 2,
					emitSlugName: "filter_status",
					filterPlaceHolder: "Statut",
					value: 1,
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [
							{ name: "Actif", id: 1 },
							{ name: "A\u00a0Valider", id: 2 },
							{ name: "A\u00a0venir", id: 8 },
							{ name: "En\u00a0pause", id: 3 },
							{ name: "Terminé", id: 4 },
							{ name: "Annulé", id: 5 },
							{ name: "Relance", id: 9 },
						],
					},
				},
				{
					order: 3,
					emitSlugName: "filter_consultant",
					filterPlaceHolder: "Consultant",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [],
					},
				},
				{
					order: 4,
					emitSlugName: "filter_period",
					filterPlaceHolder: "Période",
					value: "",
					require: true,
					type: "Date",
					params: {
						date_type: "period",
					},
				},
			],
		};
	},

	mounted() {
		this.calculateTableHeight();
		window.addEventListener("resize", this.calculateTableHeight);
	},

	beforeDestroy() {
		window.removeEventListener("resize", this.calculateTableHeight);
	},

	updated() {
		this.$nextTick(() => {
			this.calculateTableHeight();
		});
	},

	created() {
		this.fetchBudgetContracts();
		this.fetchConsultants();
		store.dispatch("getAllContractsWithContractsUsers");
		this.getConsultantDefault();
	},

	computed: {
		societies: () => {
			return store.state.societies;
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		allContractsWithContractsUsers: () => {
			return store.state.contracts_contracts_users;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		filteredContracts() {
			return this.allContracts.filter((contract) => {
				const societyMatch =
					!this.filtersTemplates[0].value ||
					contract.society_name
						.toLowerCase()
						.includes(this.filtersTemplates[0].value.toLowerCase());

				const contractIdFilter = this.filtersTemplates[1].value;
				const contractIdMatch =
					!contractIdFilter ||
					String(contract.id).includes(String(contractIdFilter));

				const statusFilter = this.filtersTemplates[2].value;
				const statusMatch =
					!statusFilter || statusFilter === contract.contract_status;

				// A contract is kept as soon as one of its prestations is handled by the
				// selected consultant, even when the displayed avatar is a different one.
				const consultantFilter = this.filtersTemplates[3].value;
				const contractConsultantIds =
					contract.consultant_ids && contract.consultant_ids.length > 0
						? contract.consultant_ids
						: [contract.consultant_id];
				const consultantMatch =
					!consultantFilter ||
					contractConsultantIds.some(
						(id) => String(id) === String(consultantFilter)
					);

				const periodFilter = this.filtersTemplates[4].value;
				const periodMatch =
					!periodFilter || periodFilter === this.selectedPeriod;

				return (
					societyMatch &&
					contractIdMatch &&
					statusMatch &&
					consultantMatch &&
					periodMatch
				);
			});
		},

		// Pagination computed properties
		paginatedContracts() {
			const start = (this.currentPage - 1) * this.itemsPerPage;
			const end = start + this.itemsPerPage;
			return this.filteredContracts.slice(start, end);
		},

		totalPages() {
			return Math.ceil(this.filteredContracts.length / this.itemsPerPage) || 1;
		},

		startItem() {
			if (this.filteredContracts.length === 0) return 0;
			return (this.currentPage - 1) * this.itemsPerPage + 1;
		},

		endItem() {
			const end = this.currentPage * this.itemsPerPage;
			return Math.min(end, this.filteredContracts.length);
		},

		totalBudgets() {
			return this.filteredContracts.reduce(
				(sum, contract) => sum + (contract.total_budget || 0),
				0
			);
		},

		totalSpent() {
			return this.filteredContracts.reduce(
				(sum, contract) => sum + (contract.total_sold_price || 0),
				0
			);
		},

		totalAvailable() {
			return this.filteredContracts.reduce(
				(sum, contract) => sum + (contract.budget_rest || 0),
				0
			);
		},
	},

	watch: {
		filterPeriod(newValue) {
			this.selectedPeriod = newValue;
		},
		filteredContracts(data) {
			store.dispatch("setRowNum", data.length);
			this.currentPage = 1; // Reset to first page when filters change
			this.$nextTick(() => {
				this.calculateTableHeight();
			});
		},
		selectedPeriod() {
			this.fetchBudgetContracts();
		},
		productSubCategory() {
			this.fetchBudgetContracts();
		},
		popupActive(isActive) {
			if (isActive) {
				this.$nextTick(() => {
					this.calculateTableHeight();
				});
			}
		},
		filtersTemplates: {
			handler(newFilters) {
				newFilters.forEach((filter, index) => {
					if (
						typeof filter.value === "object" &&
						filter.value !== null &&
						filter.value !== undefined
					) {
						console.warn(
							`Filter ${filter.emitSlugName} has object value:`,
							filter.value
						);

						if (filter.value.hasOwnProperty("value")) {
							this.filtersTemplates[index].value = filter.value.value || "";
						} else if (filter.value.hasOwnProperty("id")) {
							this.filtersTemplates[index].value = filter.value.id || "";
						} else {
							this.filtersTemplates[index].value = "";
						}
					}

					if (String(filter.value) === "[object Object]") {
						console.warn(
							`Fixing [object Object] in filter ${filter.emitSlugName}`
						);
						this.filtersTemplates[index].value = "";
					}
				});
			},
			deep: true,
		},
	},

	methods: {
		getGlobalIndex(localIndex) {
			return (this.currentPage - 1) * this.itemsPerPage + localIndex;
		},

		toggleExpand(index) {
			this.$set(this.expandedRows, index, !this.expandedRows[index]);
		},

		toggleAllExpand() {
			this.allExpanded = !this.allExpanded;
			const newExpandedRows = {};
			if (this.allExpanded) {
				// Expand all rows
				for (let i = 0; i < this.filteredContracts.length; i++) {
					newExpandedRows[i] = true;
				}
			}
			// If collapsing all, newExpandedRows remains empty
			this.expandedRows = newExpandedRows;
		},

		toggleExpandIfNotInteractive(event, index) {
			// Check if the clicked element or its parents are interactive elements
			const interactiveElements = [
				"BUTTON",
				"INPUT",
				"SELECT",
				"TEXTAREA",
				"A",
			];
			let element = event.target;

			// Walk up the DOM tree to check for interactive elements
			while (element && element !== event.currentTarget) {
				if (interactiveElements.includes(element.tagName)) {
					return; // Don't expand if clicking on an interactive element
				}
				// Check for click handlers that stop propagation
				if (element.onclick || element.getAttribute("@click")) {
					return;
				}
				element = element.parentElement;
			}

			// If we got here, it's safe to toggle expand
			this.toggleExpand(index);
		},

		// Dynamic height calculation
		calculateTableHeight() {
			this.$nextTick(() => {
				const popupContainer = this.$refs.popupContainer;
				if (!popupContainer) return;

				const containerHeight = popupContainer.clientHeight;

				const filterCard = popupContainer.querySelector(".filter-section");
				const summaryCards = popupContainer.querySelector(".budget-summary");

				let usedHeight = 0;

				if (filterCard) {
					usedHeight += filterCard.offsetHeight;
				}

				if (summaryCards) {
					usedHeight += summaryCards.offsetHeight;
				}

				const margins = 80; // Adjust based on your spacing
				const availableHeight = containerHeight - usedHeight - margins;
				const minHeight = 300;

				this.tableHeight = Math.max(availableHeight, minHeight);
			});
		},

		getSocietyById(societyId) {
			return this.societies.find((society) => society.id == societyId);
		},

		displaySocietyPopup(societyId) {
			this.selectedSociety = null;
			this.selectedSociety = JSON.parse(
				JSON.stringify(this.getSocietyById(societyId))
			);
			this.$http
				.get(this.apiUrl + "society/getImg/" + societyId)
				.then((image) => {
					let imgObject = null;
					if (image.data.length > 0) {
						imgObject = image.data;
					}
					this.selectedSociety.image = imgObject;
				})
				.catch((err) => {
					//console.log(err);
				});

			this.showSocietyPopup = true;

			let ComponentClass = Vue.extend(SocietyInfoPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					society: this.selectedSociety,
					popupActive: this.showSocietyPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
				},
			});
			societyPopup.$mount();
			this.$refs.popupContainer.appendChild(societyPopup.$el);
		},

		displayContractPopup(contract_id) {
			this.selectedContract = null;
			let foundContract = this.allContractsWithContractsUsers.findIndex(
				(row) => row.id == contract_id
			);
			if (foundContract < 0) {
				this.$vs.notify({
					title: "Erreur",
					text: "Contrat introuvable, contactez l'équipe technique.",
				});
				return false;
			}
			let account_manager_avatars = [];
			if (this.allContractsWithContractsUsers[foundContract].account_managers) {
				let contract_account_managers_names =
					this.allContractsWithContractsUsers[foundContract]
						.account_managers !== null
						? this.allContractsWithContractsUsers[
								foundContract
						  ].account_managers.split(", ")
						: [];
				let contract_account_managers = contract_account_managers_names.splice(
					0,
					contract_account_managers_names.length / 2
				);
				for (let i = 0; i < contract_account_managers.length; i++) {
					account_manager_avatars.push({
						name: contract_account_managers_names[i],
						users_id: contract_account_managers[i],
						is_lead:
							this.allContractsWithContractsUsers[foundContract].lead_am ==
							contract_account_managers[i]
								? 1
								: 0,
					});
				}
			}
			this.selectedContract =
				this.allContractsWithContractsUsers[foundContract];
			this.selectedContract.account_manager_avatars = account_manager_avatars;
			this.showContractPopup = true;

			let ComponentClass = Vue.extend(ContractInfoPopup);
			let contractPopup = new ComponentClass({
				propsData: {
					contract: this.selectedContract,
					popupActive: this.showContractPopup,
					router: this.$router,
					highZIndex: true,
				},
			});
			contractPopup.$mount();
			contractPopup.$on("modify-contract", (contractId) => {
				this.popupActive = false;
				this.modifyContract(contractId);
			});
			contractPopup.$on("modify-missions", (contractId) => {
				this.popupActive = false;
				this.modifyMissions(contractId);
			});

			this.$refs.popupContainer.appendChild(contractPopup.$el);
		},

		getConsultantDefault() {
			const thisTemplate = this.filtersTemplates.find(
				(row) => row.emitSlugName === "filter_consultant"
			);
			thisTemplate.value = this.activeUser.id;
		},

		// Mission level editing methods
		startEditMission(mission) {
			// Check if mission_id exists, if not try id
			const missionId = mission.mission_id || mission.id;
			if (!missionId) {
				console.error("Mission ID not found:", mission);
				return;
			}

			this.$set(this.editingMissions, missionId, {
				corrected_budget: mission.corrected_budget || 0,
			});
		},

		cancelEditMission(missionId) {
			this.$delete(this.editingMissions, missionId);
		},

		/**
		 * The correction is saved immediately. The note popup opens afterwards and
		 * is purely optional - "Passer" closes it and the correction stays saved.
		 */
		async saveCorrectedBudgetMission(mission, contract) {
			const missionId = mission.mission_id || mission.id;
			const amount = parseFloat(
				(this.editingMissions[missionId] || {}).corrected_budget
			) || 0;

			const saved = await this.performCorrectionSave(mission, contract);
			if (!saved) return;

			this.pendingCorrection = {item: mission, contract: contract, amount: amount};
			// Pre-fill with whatever note is already stored for this period.
			this.correctionNote = mission.correct_budget_note || "";
			this.showNotePopup = true;
		},

		/** Close without writing a note. The correction itself is already saved. */
		skipCorrectionNote() {
			this.showNotePopup = false;
			this.pendingCorrection = null;
			this.correctionNote = "";
		},

		async confirmCorrectionWithNote(note) {
			if (!this.pendingCorrection) return;
			const {item, contract} = this.pendingCorrection;
			const missionId = item.mission_id || item.id;
			this.isSavingNote = true;
			try {
				await Netlink.updateCorrectedBudgetNote({
					mission_id: missionId,
					contract_id: contract.id,
					period: this.selectedPeriod,
					correct_budget_note: note || "",
				});
				await this.fetchBudgetContracts();
				this.$vs.notify({
					title: "Succès",
					text: "Note enregistrée",
					color: "success",
				});
			} catch (error) {
				console.error("Error saving correction note:", error);
				this.$vs.notify({
					title: "Erreur",
					text: "Erreur lors de l'enregistrement de la note",
					color: "danger",
				});
			} finally {
				this.isSavingNote = false;
				this.showNotePopup = false;
				this.pendingCorrection = null;
				this.correctionNote = "";
			}
		},

		async performCorrectionSave(mission, contract) {
			try {
				// Check if mission_id exists, if not try id
				const missionId = mission.mission_id || mission.id;
				if (!missionId) {
					console.error("Mission ID not found:", mission);
					this.$vs.notify({
						title: "Erreur",
						text: "ID de mission non trouvé",
						color: "danger",
					});
					return false;
				}

				this.$set(this.savingMissions, missionId, true);

				const editedData = this.editingMissions[missionId];
				if (!editedData) {
					console.error("No editing data found for mission:", missionId);
					this.$vs.notify({
						title: "Erreur",
						text: "Données de modification non trouvées",
						color: "danger",
					});
					this.$delete(this.savingMissions, missionId);
					return false;
				}

				const updateData = {
					mission_id: missionId,
					contract_id: contract.id,
					corrected_budget: parseFloat(editedData.corrected_budget) || 0,
					period: this.selectedPeriod,
					// correct_budget_note is deliberately omitted: the note is saved
					// separately afterwards, and sending nothing leaves any existing
					// note untouched rather than wiping it.
				};

				console.log("Saving mission correction:", updateData);
				await Netlink.updateCorrectedBudgetMission(updateData);

				this.$delete(this.editingMissions, missionId);

				// Reload all budget contracts to get fresh data
				await this.fetchBudgetContracts();

				this.$vs.notify({
					title: "Succès",
					text: "Correction budgétaire de la mission mise à jour avec succès",
					color: "success",
				});
				return true;
			} catch (error) {
				console.error("Error saving mission correction:", error);
				this.$vs.notify({
					title: "Erreur",
					text: "Erreur lors de la sauvegarde de la correction budgétaire de la mission",
					color: "danger",
				});
				return false;
			} finally {
				const missionId = mission.mission_id || mission.id;
				if (missionId) {
					this.$delete(this.savingMissions, missionId);
				}
			}
		},

		async fetchConsultants() {
			try {
				await store.dispatch("getAllCollaborators");
				const collaborators = this.allCollaborators;
				const consultants = collaborators
					.filter((collaborator) => [3, 6, 7, 9].includes(collaborator.type))
					.sort((a, b) => a.firstname.localeCompare(b.firstname))
					.map((collaborator) => ({
						id: collaborator.id,
						name: `${collaborator.firstname} ${collaborator.lastname}`,
					}));

				this.filtersTemplates.find(
					(f) => f.emitSlugName === "filter_consultant"
				).params.dropdownValues = consultants;
				this.filterRefreshKey++;
			} catch (error) {
				console.error("Error fetching consultants:", error);
				this.$vs.notify({
					title: "Erreur",
					text: "Erreur lors de la récupération des consultants",
					color: "danger",
				});
			}
		},

		async fetchBudgetContracts() {
			try {
				this.isLoading = true;

				const params = {
					period: this.selectedPeriod,
					product_sub_category: this.productSubCategory,
					page: 1,
					limit: 1000,
				};

				console.log("Fetching budget contracts with params:", params);
				const response = await Netlink.getBudgetRecap(params);
				console.log("Budget recap API response:", response);

				this.allContracts = response;

				this.allContracts = this.allContracts.map((contract) => ({
					...contract,
					period_budget: parseFloat(contract.period_budget) || 0,
					total_budget: parseFloat(contract.total_budget) || 0,
					total_sold_price: parseFloat(contract.total_sold_price) || 0,
					budget_rest: parseFloat(contract.budget_rest) || 0,
					corrected_budget: parseFloat(contract.corrected_budget) || 0,
					contract_start_date: contract.contract_start_date
						? new Date(contract.contract_start_date)
						: null,
					contract_end_date: contract.contract_end_date
						? new Date(contract.contract_end_date)
						: null,
					// Parse mission items and filter by period
					items: contract.items
						? contract.items
								.filter((item) => {
									// Filter missions to only show those matching the selected period
									if (!item.mission_start_date) return true; // Include if no start date
									const missionStartPeriod = moment(
										item.mission_start_date
									).format("MM/YYYY");
									return missionStartPeriod === this.selectedPeriod;
								})
								.map((item) => ({
									...item,
									mission_budget: parseFloat(item.mission_budget) || 0,
									last_budget_rest: parseFloat(item.last_budget_rest) || 0,
									corrected_budget: parseFloat(item.corrected_budget) || 0,
									total_budget: parseFloat(item.total_budget) || 0,
									total_sold_price: parseFloat(item.total_sold_price) || 0,
									budget_rest: parseFloat(item.budget_rest) || 0,
								}))
						: [],
				}));
			} catch (error) {
				console.error("Error fetching budget contracts:", error);
				this.$vs.notify({
					title: "Erreur",
					text: "Erreur lors du chargement des contrats",
					color: "danger",
				});
			} finally {
				this.isLoading = false;
				this.calculateTableHeight();
			}
		},

		convertToReadableDate(date) {
			return moment(date).format("DD/MM/YYYY");
		},

		formatCurrency(amount) {
			if (amount === null || amount === undefined) return "0,00 €";
			return new Intl.NumberFormat("fr-FR", {
				style: "currency",
				currency: "EUR",
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			}).format(amount);
		},

		getStatusColor(status) {
			const statusColors = {
				active: "success",
				inactive: "warning",
				pending: "primary",
				expired: "danger",
			};
			return statusColors[status] || "primary";
		},

		getBudgetAvailableClass(amount) {
			if (amount < 0) return "negative";
			return "positive";
		},

		checkBudgetRange(budget, rangeValue) {
			if (
				!rangeValue ||
				rangeValue === "" ||
				rangeValue === null ||
				rangeValue === undefined
			) {
				return true;
			}

			const budget_num = parseFloat(budget) || 0;

			switch (String(rangeValue)) {
				case "0-10000":
					return budget_num >= 0 && budget_num <= 10000;
				case "10000-50000":
					return budget_num > 10000 && budget_num <= 50000;
				case "50000-100000":
					return budget_num > 50000 && budget_num <= 100000;
				case "100000+":
					return budget_num > 100000;
				default:
					return true;
			}
		},

		handleFilterEmits([emitSlugName, value]) {
			const filter = this.filtersTemplates.find(
				(f) => f.emitSlugName === emitSlugName
			);
			if (filter) {
				if (value === null || value === undefined) {
					filter.value = "";
				} else if (typeof value === "object" && value !== null) {
					filter.value = value.value || value.id || "";
				} else {
					filter.value = value;
				}

				if (emitSlugName === "filter_contract_id" && filter.value !== "") {
					filter.value = String(filter.value);
				}

				if (emitSlugName === "filter_consultant" && filter.value !== "") {
					filter.value = String(filter.value);
				}

				if (emitSlugName === "filter_period" && filter.value !== "") {
					this.filterPeriod = filter.value;
				}
			}
		},

		resetAllFilter() {
			this.filtersTemplates.forEach((filter) => {
				filter.value = "";
			});
			this.filterPeriod = moment().format("MM/YYYY");
			this.filterRefreshKey++;
		},

		viewContractDetails(contract) {
			this.$emit("view-contract-details", contract);
		},

		async refreshData() {
			await this.fetchBudgetContracts();
		},

		debugConsultantFilter() {
			const consultantFilter = this.filtersTemplates[3].value;
			console.log("Selected consultant ID:", consultantFilter);
			console.log(
				"Contracts matching consultant:",
				this.allContracts.filter((c) =>
					(c.consultant_ids || [c.consultant_id]).some(
						(id) => String(id) === String(consultantFilter)
					)
				)
			);
		},

		getConsultantNameById(consultantId) {
			const consultant = this.filtersTemplates
				.find((f) => f.emitSlugName === "filter_consultant")
				.params.dropdownValues.find((c) => c.id === parseInt(consultantId));
			return consultant ? consultant.name : "Unknown";
		},

		debugFilters() {
			console.log(
				"Current filter values:",
				this.filtersTemplates.map((f) => ({
					name: f.emitSlugName,
					value: f.value,
					type: typeof f.value,
					stringValue: String(f.value),
				}))
			);
		},

		displayBacklinksPopup(contract, item) {
			this.showBacklinksPopup = true;
			let ComponentClass = Vue.extend(BacklinksContractPopup);
			let backlinksContractPopup = new ComponentClass({
				propsData: {
					popupActive: this.showBacklinksPopup,
					contractId: contract.id,
					societyName: contract.society_name,
					societyId: contract.society_id || contract.contract_society_id,
					mission: item,
				},
			});
			backlinksContractPopup.$mount();

			// Listen for data-updated event and refresh budget contracts
			backlinksContractPopup.$on("data-updated", () => {
				console.log(
					"Data updated in BacklinksContractPopup, refreshing budget contracts..."
				);
				this.fetchBudgetContracts();
			});

			this.$refs.popupContainer.appendChild(backlinksContractPopup.$el);
		},

		openCalculator() {
			// Open the calculator popup
			this.showCalculatorPopup = true;
		},

		handleCalculationComplete(data) {
			// Handle the calculation results
			console.log("Calculation complete:", data);

			// Show the results
			// this.$vs.notify({
			//     title: 'Calcul effectué',
			//     text: `Prix d'achat: ${data.purchasePrice}€ → Prix de vente: ${data.salePrice}€ (Marge: ${data.marginPercentage})`,
			//     color: 'success',
			//     position: 'top-right'
			// });

			// You can use these values for further operations
			// For example, updating a field in a form or table
		},
	},
};
</script>


<style scoped>
/* Popup and container styles for full height */
.vs-popup {
	height: 100vh !important;
}

.vs-popup__content {
	height: 100% !important;
	display: flex;
	flex-direction: column;
}

.popup-container {
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
}

.filter-section {
	flex-shrink: 0;
}

.budget-summary {
	flex-shrink: 0;
	padding: 0;
	margin-top: 0.5rem !important;
}

.table-container {
	flex: 2;
	display: flex;
	flex-direction: column;
	min-height: 0;
}

/* Custom table wrapper */
.custom-table-wrapper {
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

/* Custom table styles */
.custom-budget-table {
	width: 100%;
	border-collapse: collapse;
	background: white;
	overflow-y: auto;
	flex: 1;
}

.custom-budget-table thead {
	background-color: #0c293d !important;
	position: sticky;
	top: 0;
	z-index: 10;
}

.custom-budget-table thead th {
	background-color: #0c293d !important;
	color: white !important;
	padding: 1px 5px !important;
	text-align: left;
	font-weight: 500;
	border-bottom: 2px solid #0a1f2e;
	height: 18px !important;
	max-height: 18px !important;
	line-height: 1.1;
	font-size: 11px;
}

.custom-budget-table tbody tr {
	height: 18px !important;
	max-height: 18px !important;
	border-bottom: 1px solid #f0f0f0ff;
}

.custom-budget-table tbody tr.main-row:hover {
	background-color: #f0f0f0ff;
}

.custom-budget-table tbody tr.main-row:nth-child(odd) {
	background-color: #f0f0f0ff;
}

.custom-budget-table td {
	padding: 1px 5px !important;
	vertical-align: middle;
	line-height: 1.1;
	font-size: 11px;
	height: 18px !important;
	max-height: 18px !important;
	overflow: hidden;
}

.custom-budget-table th {
	overflow: hidden;
}

/* Expanded item row styles */
.custom-budget-table .expanded-item-row {
	background-color: #ffffffff !important;
	height: 20px !important;
	max-height: 20px !important;
}

.custom-budget-table .expanded-item-row:hover {
	background-color: #e8f4f9 !important;
}

.custom-budget-table .expanded-item-row td {
	padding: 3px 5px !important;
	line-height: 1.1;
	font-size: 11px;
	height: 20px !important;
	max-height: 20px !important;
}

/* Force smaller buttons in table */
.custom-budget-table .vs-button {
	height: 16px !important;
	min-height: 16px !important;
	padding: 13px 3px !important;
	font-size: 9px !important;
}

.custom-budget-table .vs-button .vs-icon {
	font-size: 11px !important;
}

/* Force smaller chips */
.custom-budget-table .vs-chip {
	height: 16px !important;
	padding: 0px 5px !important;
	font-size: 9px !important;
	line-height: 1.1 !important;
}

/* Force smaller input fields */
.custom-budget-table .vs-input {
	height: 16px !important;
	font-size: 9px !important;
}

.custom-budget-table .vs-inputx {
	padding: 0px 3px !important;
}

/* Override any nested component heights */
.custom-budget-table td > div,
.custom-budget-table td > span {
	line-height: 1.1 !important;
}

/* Avatar chip overrides */
.custom-budget-table .avatar-message-chip {
	height: 16px !important;
	max-height: 16px !important;
}

.custom-budget-table .avatar-message-chip .vs-avatar {
	width: 16px !important;
	height: 16px !important;
	min-width: 16px !important;
	font-size: 8px !important;
}

/* Expand icon overrides */
.custom-budget-table .expand-icon-wrapper {
	padding: 1px !important;
	display: flex;
	justify-content: center;
	align-items: center;
}

.custom-budget-table .expand-icon-wrapper .vs-icon {
	font-size: 14px !important;
	width: 14px !important;
	height: 14px !important;
	line-height: 14px !important;
}

/* Custom pagination styles */
.custom-pagination {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px;
	background: white;
	border-top: 1px solid #e0e6ed;
	flex-shrink: 0;
}

.pagination-info {
	color: #626262;
	font-size: 11px;
}

.pagination-controls {
	display: flex;
	align-items: center;
	gap: 12px;
}

.page-number {
	font-weight: 600;
	color: #626262;
	min-width: 60px;
	text-align: center;
	font-size: 11px;
}

.loading-container {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 400px;
}

/* Existing styles */
.budget-amount {
	font-weight: 600;
	font-family: "Monaco", "Menlo", monospace;
}

.budget-amount.total {
	color: #1976d2;
}

.budget-amount.spent {
	color: #d32f2f;
}

.budget-amount.positive {
	color: #388e3c;
	font-weight: bold;
}

.budget-amount.negative {
	color: #d32f2f;
	font-weight: bold;
}

.budget-amount.low {
	color: #f57c00;
}

.contract-chip {
	font-family: "Monaco", "Menlo", monospace;
	font-size: 0.9em;
}

.status-chip {
	text-transform: capitalize;
}

.summary-cards {
	display: flex;
	gap: 0.5rem;
	flex-wrap: wrap;
}

.summary-card {
	flex: 1;
	min-width: 150px;
	padding: 0.5rem 0.75rem !important;
}

.summary-card .vs-card__content {
	padding: 0 !important;
}

.summary-content {
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
}

.summary-content h4 {
	margin: 0 !important;
	color: #666;
	font-size: 0.825rem;
	text-transform: uppercase;
	letter-spacing: 0.3px;
	line-height: 1.2;
}

.summary-content p {
	margin: 0 !important;
	font-size: 0.75rem;
}

.summary-content .flex {
	align-items: center;
	gap: 0.5rem;
}

.summary-amount {
	font-size: 1.25rem;
	font-weight: bold;
	font-family: "Monaco", "Menlo", monospace;
	line-height: 1.2;
}

.summary-amount.spent {
	color: #d32f2f;
}

.summary-amount.available {
	color: #08adb5;
}

.negative {
	color: #d32f2f;
	font-weight: bold;
}

.positive {
	color: #388e3c;
	font-weight: bold;
}

.edit-container {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.edit-input {
	width: 120px;
	text-align: right;
}

.action-buttons {
	display: flex;
	justify-content: center;
	align-items: center;
}

.edit-actions {
	display: flex;
	gap: 0.5rem;
}

.edit-actions .vs-button {
	padding: 0.25rem 0.5rem;
	font-size: 0.8rem;
}

/* Expand row styles */
.expand-row td {
	background-color: #ffffffff;
	padding: 20px !important;
}

.expand-icon-wrapper:hover {
	background-color: rgba(0, 0, 0, 0.05);
	border-radius: 4px;
}

/* Calculator button styles */
.calculator-button-wrapper {
	position: absolute;
	right: 20px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 10;
}

.calculator-button {
	border: 0px !important;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	transition: all 0.3s ease;
	padding: 10px 20px !important;
}

.calculator-button:hover {
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
	transform: scale(1.05);
}

/* Correction note: info icon next to the edit button, tooltip carries the text */
.note-info-wrapper {
	margin-left: 2px;
	line-height: 1;
}

.note-info-icon {
	font-size: 14px !important;
	cursor: help;
}

/* The shared .custom-tooltip clamps to 3 lines for the short budget warning;
   a correction note is free text and needs the room. */
.note-tooltip {
	max-height: none;
	-webkit-line-clamp: unset;
	display: block;
	min-width: 240px;
	max-width: 360px;
	white-space: pre-wrap;
	text-align: left;
}

/* Consultant cell */
.consultant-cell {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 2px;
}

/* Custom Tooltip Styles */
.custom-tooltip-wrapper {
	position: relative;
	display: inline-flex;
	align-items: center;
	cursor: pointer;
}

.custom-tooltip {
	position: absolute;
	bottom: 100%;
	left: 50%;
	transform: translateX(-50%) translateY(-8px);
	background-color: #333;
	color: white;
	padding: 8px 12px;
	border-radius: 4px;
	font-size: 12px;
	white-space: normal;
	word-wrap: break-word;
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.3s ease;
	z-index: 99999;
	min-width: 350px;
	max-width: 500px;
	max-height: 3.6em;
	overflow: hidden;
	text-align: center;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
	line-height: 1.2em;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
}

.custom-tooltip::after {
	content: "";
	position: absolute;
	top: 100%;
	left: 50%;
	transform: translateX(-50%);
	border-width: 5px;
	border-style: solid;
	border-color: #333 transparent transparent transparent;
}

.custom-tooltip-wrapper:hover .custom-tooltip {
	opacity: 1;
}

/* Responsive design */
@media (max-width: 768px) {
	.summary-cards {
		flex-direction: column;
	}

	.summary-card {
		min-width: 100%;
	}

	.edit-actions {
		flex-direction: column;
		gap: 0.25rem;
	}

	.calculator-button-wrapper {
		right: 40px;
	}

	.custom-tooltip {
		left: auto;
		right: 0;
		transform: translateY(-8px);
	}

	.custom-tooltip::after {
		left: auto;
		right: 20px;
	}
}
</style>